import styled from "styled-components";

export const SettingsHeader = styled.div`
  font-size: 26px;
  font-weight: 700;
  color: ${(props) => props.theme.darkGray};
  margin-bottom: 16px;
`;
